module.exports = __webpack_public_path__ + "img/ANTENNA RADIO 2 GREEN.e1fd608.svg";